import { Navigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import useAuthStore from '../store/authStore'
import useFeaturesStore from '../store/featuresStore'
import Loading from './Loading'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, fetchUser } = useAuthStore()
  const loadFeatures = useFeaturesStore((s) => s.load)
  const location = useLocation()
  const [checking, setChecking] = useState(true)

  useEffect(() => {
    const token = localStorage.getItem('access_token')
    if (token) {
      // Always re-validate user on mount: persisted state may be stale.
      // Carico anche i feature flag così la sidebar/route mostrano subito
      // le sezioni abilitate dal backend.
      fetchUser()
        .then(() => loadFeatures())
        .finally(() => setChecking(false))
    } else {
      setChecking(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loading compact />
      </div>
    )
  }

  if (!isAuthenticated && !localStorage.getItem('access_token')) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}
